module.exports = __webpack_public_path__ + "img/doorLogo21.feb8d628.png";